export default __webpack_public_path__ + "static/media/NTEX SYLLABUS_2026-27 CLASS 6.e1329218.pdf";